module.exports = __webpack_public_path__ + "static/img/mo.144efd00.svg";